import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
// import AlertMap from './screen/AlertMapScreen';
import FeeShippingMap from './screen/FeeShippingMapScreen';
import ShippingDriverMap from './screen/ShippinDriverMapScreen';
import ConfirmMap from './screen/ConfirmationMapScreen';
import ConfirmationScreen from './screen/ConfirmationScreen';
import PrivacyPolicyScreen from './screen/PrivacyPolicyScreen';
import DeleteAccountPage from './screen/DeleteAccountDriverScreen';

// import ConfirmMapSeller from './screen/ConfirmationMapSellerScreen';
// import DriverMap from './driverScreen/DriverMapScreen';
import DriverHomeMap from './driverScreen/DriverHomeMapScreen';
import ClientHomeMap from './clientScreen/ClientHomeMapScreen';
import ClientAcceptCourseScreen from './clientScreen/ClientAcceptCourseScreen';
import ClientDriverConnectMap from './clientScreen/ClientDriverConnectMapScreen';
import ClientPaymentMap from './clientScreen/ClientPaymentMapScreen';
import ClientRoutingMap from './clientScreen/ClientRoutingMapScreen';
import ClientVerifiedPickupMap from './clientScreen/ClientVerifiedPickupMapScreen';
import ClientVerifiedDeliveredMap from './clientScreen/ClientVerifiedDeliveredMapScreen';
import DriverPickupRouting from './driverScreen/DriverPickupRoutingScreen';
import DriverDeliveredRouting from './driverScreen/DriverDeliveredRoutingScreen';
import AlertClientMap from './clientScreen/AlertClientMapScreen';
import AlertDriverMap from './driverScreen/AlertDriverMapScreen';
import ClientShareMap from './clientScreen/ClientShareMapScreen';
import DriverShareMap from './driverScreen/DriverShareMapScreen';


function App() {

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/clientHomeMap" element={<ClientHomeMap />} />
          <Route path="/clientShareMap" element={<ClientShareMap />} />
          <Route path="/clientVerifiedPickupMap" element={<ClientVerifiedPickupMap />} />
          <Route path="/clientVerifiedDeliveredMap" element={<ClientVerifiedDeliveredMap />} />
          <Route path="/clientPaymentMap" element={<ClientPaymentMap />} />
          <Route path="/clientRoutingMap" element={<ClientRoutingMap />} />
          <Route path="/clientDriverConnectMap" element={<ClientDriverConnectMap />} />
          <Route path="/clientAcceptCourse" element={<ClientAcceptCourseScreen />} />

          {/* <Route path="/alertMap" element={<AlertMap />} /> */}
          <Route path="/alertClientMap" element={<AlertClientMap />} />
          <Route path="/alertDriverMap" element={<AlertDriverMap />} />


          {/* <Route path="/driverMap" element={<DriverMap />} /> */}
          <Route path="/driverHomeMap" element={<DriverHomeMap />} />
          <Route path="/driverShareMap" element={<DriverShareMap />} />
          <Route path="/driverPickup" element={<DriverPickupRouting />} />
          <Route path="/driverDelivered" element={<DriverDeliveredRouting />} />

          <Route path="/feeShippingMap" element={<FeeShippingMap />} />
          <Route path="/shippingDriverMap" element={<ShippingDriverMap />} />

          <Route path="/confirmMap" element={<ConfirmMap />} />
          {/* <Route path="/confirmMapSeller" element={<ConfirmMapSeller />} /> */}
          <Route path="/confirm" element={<ConfirmationScreen />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicyScreen />} />

          <Route path="/DeleteDriverAccount" element={<DeleteAccountPage />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
